import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ApolloProvider} from "react-apollo";
import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from "apollo-boost";
import {BrowserRouter as Router} from "react-router-dom";
import Route from "react-router-dom/Route";
import {CIBER_SCHEMA} from "./apollo/Schema";
import InscriptionApp from "./main/InscriptionApp";

let httpLink;

if (process.env.PUBLIC_URL.indexOf('appsprod') >= 0) {
  httpLink = new HttpLink({uri: 'https://appsprod.cibercolegios.com/api/vendorsauth'});
} else {
  httpLink = new HttpLink({uri: 'https://appsprod.cibercolegios.com/api/vendorsauth'});

}

const authLink = new ApolloLink((operation, forward) => {
  let loc = window.location.href;
  operation.setContext({
    headers: {
      auth_token: loc.split("/")[loc.split("/").length-1]
    }
  });

  return forward(operation);
});

const client = new ApolloClient({
  link: authLink.concat(httpLink), // Chain it with the HttpLink
  cache: new InMemoryCache(),
  typeDefs: CIBER_SCHEMA
});

class App extends React.Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <div>
          <div className="container">
            <br/>
            <div className="row">
              <Router>
                  <Route path="/" component={InscriptionApp} />
              </Router>
            </div>
          </div>
        </div>
      </ApolloProvider>
    );
  }
}

export default App;
